module.exports = __webpack_public_path__ + "static/media/business-dashboard.ae012adb.png";